// VideoDetail.jsx
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import ReactPlayer from "react-player";
import { Typography, Box, Stack } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { Videos, Loader } from "./";
import { fetchFromAPI } from "../utils/fetchFromAPI";

const VideoDetail = () => {
  const [videoDetail, setVideoDetail] = useState(null);
  const [videos, setVideos] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    // Fetch video details
    fetchFromAPI(`videos?part=snippet,statistics&id=${id}`)
      .then((data) => setVideoDetail(data.items[0]));
  
    // Fetch keywords/tags of the current video
    fetchFromAPI(`videos?part=snippet&id=${id}`)
      .then((data) => {
        const keywords = data.items[0]?.snippet?.tags || [];
        const query = keywords.join('|');
        
        // Fetch related videos based on keywords
        fetchFromAPI(`search?part=snippet&type=video&q=${query}`)
          .then((data) => setVideos(data.items));
      });
  }, [id]);

  if (!videoDetail?.snippet) return <Loader />;

  const { snippet: { title, channelId, channelTitle }, statistics: { viewCount, likeCount } } = videoDetail;

  return (
    /* Full page */
    <Box minHeight="95vh" sx={{ zoom: '100%', background: ''}}>
      <Stack direction={{ xs: "column", md: "row" }}>
        <Box flex={1}>
          {/* Video and Video Description Box Div - this is whole section with video so paddingBottom does not affect the video detail box */}
          <Box sx={{ background: '', width: "100%", position: "sticky", top: "86px", paddingBottom: "20px" }}> 
          
            <ReactPlayer url={`https://www.youtube.com/watch?v=${id}`} className="react-player" 
            controls
             />

            <Typography color="#fff" variant="h5" fontWeight="bold" p={2} sx={{ fontSize: "20px", padding: "10px 10px 0px 15px"}} >
              {title}
            </Typography>

            <Stack direction="row" justifyContent="space-between" sx={{ color: "#fff" }} py={1} px={2} >

              <Link to={`/channel/${channelId}`}>
                <Typography variant={{ sm: "subtitle1", md: 'h6' }}  color="#fff" >
                  {channelTitle}
                  <CheckCircleIcon sx={{ background: '', fontSize: "14px", color: "gray", ml: "5px" }} />
                </Typography>
              </Link>
              {/* Views text */}
              <Stack direction="row" gap="20px" alignItems="center">
                <Typography variant="body1" sx={{background: '', opacity: 0.7, fontSize: '14px' }}>
                  {parseInt(viewCount).toLocaleString()} views
                </Typography>
              {/* Likes text */}
                <Typography variant="body1" sx={{ background: '', opacity: 0.7, fontSize: '14px' }}>
                  {parseInt(likeCount).toLocaleString()} likes
                </Typography>
              </Stack> {/* Views and likes text */} 

            </Stack>
          </Box>
        </Box>

        {/* Related Videos Box */}
        <Box px={2} py={{ md: 1, xs: 5 }} justifyContent="center" alignItems="center" sx={{background: '', overflowY: 'normal'}} >
          {/* Chat added: Display videos from the same category */}
          <Videos videos={videos} direction="column" />
          {/* Chat added: End of related videos */}
        </Box>

      </Stack>
    </Box>
  );
};

export default VideoDetail;
// VideoDetail.jsx